(function () {
  const threekit = {};
  window.orgId = "abedcaa1-9c60-4322-b18b-04bf3a62106b";
  window.token = "ab7cdc50-dfe1-408e-9069-2115cb17d488";
  window.mapTableId = "fbeb94e1-3683-4426-acb2-c72ba51d49b7";
  window.threekit_env = "admin-fts";

  threekit.colorCodes = {
    BLF001: 'Matte Crystal Black',
    BLT001: 'Matte Crystal Black',
    BLF005: 'Matte Crystal Black',
    BLT005: 'Matte Crystal Black',
    BLF002: 'Matte Crystal Champagne',
    BLT008: 'Matte Crystal Champagne Fade',
    BLF007: 'Matte Crystal Blue',
    BLT003: 'Matte Crystal Champagne Fade',
    BLF003: 'Matte Crystal Blue',
    BLT006: 'Matte Crystal Blue Fade',
    BLF006: 'Matte Crystal Champagne',
    BLT002: 'Matte Crystal Blue Fade',
    BLF004: 'Matte Crystal Clear',
    BLT007: 'Matte Crystal Clear',
    BLF008: 'Matte Crystal Clear',
    BLT004: 'Matte Crystal Clear',
    BLL005: 'Smoke Mirror // Polarized',
    BLL001: 'Smoke Mirror // Polarized',
    BLL006: 'Champagne Mirror // Polarized',
    BLL002: 'Champagne Mirror // Polarized',
    BLL007: 'Peach Lime Mirror // Polarized',
    BLL003: 'Peach Lime Mirror // Polarized',
    BLL008: 'Crystal Orb Mirror // Polarized',
    BLL004: 'Crystal Orb Mirror // Polarized',
  };

  const infoProducts = {
    "Style Mil": {
      "Frame": {
        "content": [
          "<p>Our best-selling style is now customizable! Experience the bold shape and striking single-lens look of ‘Millenia X2,’ available in your choice of frame, temples, and lens color for a total of 64 BlendLab design possibilities.</p>",
          "<li><strong>Steps</strong>: Select your frame, temples and lens.</li>",
          "<li><strong>Millenia X2 Style</strong>: Bold shape and striking single-lens design.</li>",
          "<li><strong>Frame</strong>: All-matte finish available in clear, black, blue and champagne.</li>",
          "<li><strong>Fit / Size</strong>: Medium - Large.</li>",
          "<li><strong>Final Sale</strong>: Due to its custom nature, this product is excluded from our free return policy.</li>"
        ]
      },
      "Temple": {
        "content": [
          "<p>Our best-selling style is now customizable! Experience the bold shape and striking single-lens look of ‘Millenia X2,’ available in your choice of frame, temples, and lens color for a total of 64 BlendLab design possibilities.</p>",
          "<li><strong>Steps</strong>: Select your frame, temples and lens.</li>",
          "<li><strong>Temples</strong>: All-matte finish available in clear, black, blue and champagne.</li>",
          "<li><strong>Fit / Size</strong>: Medium - Large.</li>",
          "<li><strong>Final Sale</strong>: Due to its custom nature, this product is excluded from our free return policy.</li>"
        ]
      },
      "Lens": {
        "content": [
          "<p>Our best-selling style is now customizable! Experience the bold shape and striking single-lens look of ‘Millenia X2,’ available in your choice of frame, temples, and lens color for a total of 64 BlendLab design possibilities.</p>",
          "<li><strong>Steps</strong>: Select your frame, temples and lens.</li>",
          "<li><strong>Millenia X2 Style</strong>: Bold shape and striking single-lens design.</li>",
          "<li><strong>Polarized PureBlend™ Lens</strong>: Our premium lens with superior scratch resistance, all-world clarity and durability.</li>",
          "<li><strong>UV Rating</strong>: 100% UV Protection.</li>",
          "<li><strong>Final Sale</strong>: Due to its custom nature, this product is excluded from our free return policy.</li>"
        ]
      }
    },
    "Style L": {
      "Frame": {
        "content": [
          "<p>Our ‘L Series’ style is a true fan favorite featuring a timeless shape, lightweight frame, and all-matte finish. BlendLab puts you at the center of the design process with your choice of frame, temples, and lens color for a total of 64 BlendLab design possibilities.</p>",
          "<li><strong>Steps</strong>: Select your frame, temples and lens.</li>",
          "<li><strong>L Series Style</strong>: Classic, round-shaped sunglasses perfect for all face shapes.</li>",
          "<li><strong>Frame</strong>: All-matte finish available in clear, black, blue and champagne. </li>",
          "<li><strong>Fit / Size</strong>: Medium - Large.</li>",
          "<li><strong>Final Sale</strong>: Due to its custom nature, this product is excluded from our free return policy.</li>"
        ]
      },
      "Temple": {
        "content": [
          "<p>Our ‘L Series’ style is a true fan favorite featuring a timeless shape, lightweight frame, and all-matte finish. BlendLab puts you at the center of the design process with your choice of frame, temples, and lens color for a total of 64 BlendLab design possibilities.</p>",
          "<li><strong>Steps</strong>: Select your frame, temples and lens.</li>",
          "<li><strong>L Series Style</strong>: Classic, round-shaped sunglasses perfect for all face shapes</li>",
          "<li><strong>Temples</strong>: All-matte finish available in clear, black, blue and champagne. </li>",
          "<li><strong>Fit / Size</strong>: Medium - Large.</li>",
          "<li><strong>Final Sale</strong>: Due to its custom nature, this product is excluded from our free return policy.</li>"
        ]
      },
      "Lens": {
        "content": [
          "<p>Our ‘L Series’ style is a true fan favorite featuring a timeless shape, lightweight frame, and all-matte finish. BlendLab puts you at the center of the design process with your choice of frame, temples, and lens color for a total of 64 BlendLab design possibilities.</p>",
          "<li><strong>Steps</strong>: Select your frame, temples and lens.</li>",
          "<li><strong>L Series Style</strong>: Classic, round-shaped sunglasses perfect for all face shapes.</li>",
          "<li><strong>Polarized PureBlend™ Lens</strong>: Our premium lens with superior scratch resistance, all-world clarity and durability.</li>",
          "<li><strong>UV Rating</strong>: 100% UV Protection.</li>",
          "<li><strong>Final Sale</strong>: Due to its custom nature, this product is excluded from our free return policy.</li>"
        ]
      }
    }
  };


  threekit.isChangeModelOpen = false;
  threekit.modelToPostfix = { 'L Series': 'Style L', 'Millenia X2': 'Style Mil' };

  threekit.activeTab = 'Frame';
  threekit.attributeOption = 'BLF001';

  const getAttributeKey = () => `${threekit.activeTab} ${threekit.postFix}`;

  threekit.setActiveTab = (newTab) => {
    threekit.activeTab = newTab;
    setOptionList();
    renderProductDetails()
  };

  threekit.setAttributeOption = async (newOption) => { // set swatch upon click
    window.isPlayerLoading = true
    toggleLoadingClasses();
    renderProductDetails()
    const titleColor = document.getElementById('treekit-tab-title');
    titleColor.innerHTML = '';
    const titleColorSpan = document.createElement('span');
    titleColorSpan.innerHTML = 'Color: ';
    titleColorSpan.classList.add('blenders-tab-title');
    titleColor.appendChild(titleColorSpan);
    const titleColorValue = document.createElement('span');
    titleColorValue.innerHTML = threekit.colorCodes[newOption]; // set active colot title
    titleColorValue.classList.add('blenders-tab-color-title');
    titleColor.appendChild(titleColorValue);

    // set player attribute
    const configurator = await window.player.getConfigurator();
    const attribute = getAttributeKey();
    await configurator.setConfiguration({ [attribute]: newOption });
    threekit.attributeOption = newOption;

    threekit.variantId = window.threekit.variants[newOption];

    window.isPlayerLoading = false
    toggleLoadingClasses();

    // set 'add to cart' variant id
    const configuration = configurator.getConfiguration();
    const option1 = configuration[`Frame ${threekit.postFix}`];
    const option2 = configuration[`Temple ${threekit.postFix}`];
    const option3 = configuration[`Lens ${threekit.postFix}`];
    const key = `${option1}_${option2}_${option3}`;
    const addToCartSubmit = document.getElementById('threekit-submit-form');
    addToCartSubmit.value = window.threekit.variants[key];
  };

  function toggleConfiguratorStyles() { // show/hide "change model" panel
    const configuratorPanel = document.getElementById('configurator-panel');
    const changeModelPanel = document.getElementById('changeModel-panel');
    configuratorPanel.style.display = threekit.isChangeModelOpen ? 'none' : 'block';
    changeModelPanel.style.display = threekit.isChangeModelOpen ? 'block' : 'none';
  }

  threekit.setChangeModelOpen = async () => {
    threekit.isChangeModelOpen = !threekit.isChangeModelOpen;
    toggleConfiguratorStyles();
  };

  threekit.changeModel = async (newModel) => {
    renderProductDetails()
    const configurator = window.player.getConfigurator();
    configurator.then(resp => { resp.setConfiguration({ Type: newModel }); });
    window.threekitModel = newModel;
    window.threekit.postFix = threekit.modelToPostfix[newModel];;
    threekit.setActiveTab('Frame');
    threekit.setChangeModelOpen();
    const modelTitle = document.getElementById('modelTitle');
    modelTitle.innerHTML = newModel;
  };


  function fetchProductOptions(options, callback) {
    const url = `https://${options.env}.threekit.com/api/datatables/${options.datatableId}/rows?orgId=${options.orgId}&all=true&bearer_token=${options.authToken}`;

    fetch(url, {
      headers: {
        authorization: `Bearer ${options.authToken}`,
      },
      credentials: "include",
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        return response.rows.map(function (row) {
          return row.value;
        });
      })
      .then(callback);
  }
  async function renderProductDetails() {
    document.getElementById('custom-product-info').innerHTML = infoProducts[threekit.postFix][threekit.activeTab].content.join('<br>');
  }

  async function setOptionList() { 
    const attributes = window.threekit.attributes; // getAttributes();
    const key = getAttributeKey();
    renderProductDetails();
    const swatchesContainer = document.getElementById('swatches-container');
    swatchesContainer.replaceChildren(); // reset swatches on tab panel change
    const titleColor = document.getElementById('treekit-tab-title');
    titleColor.innerHTML = '';
    const titleColorSpan = document.createElement('span');
    titleColorSpan.innerHTML = 'Color: ';
    titleColorSpan.classList.add('blenders-tab-title');
    titleColor.appendChild(titleColorSpan);
    const titleColorValue = document.createElement('span');
    titleColorValue.classList.add('blenders-tab-color-title');
    titleColor.appendChild(titleColorValue);

    const configurator = await window.player.getConfigurator();
    const configuration = await configurator.getConfiguration();
    // active tab option is null
    const option1 = threekit.activeTab === 'Frame' ? null : configuration[`Frame ${threekit.postFix}`];
    const option2 = threekit.activeTab === 'Temple' ? null : configuration[`Temple ${threekit.postFix}`];
    const option3 = threekit.activeTab === 'Lens' ? null : configuration[`Lens ${threekit.postFix}`];

    titleColorValue.innerHTML = `${threekit.colorCodes[configuration[key]]}`;
    const configurationKey = configuration[key];

    attributes[key].forEach((option) => {
      // build shopify variant key
      const key = `${option1 || option}_${option2 || option}_${option3 || option}`;
      const colorTitle = threekit.colorCodes[option];

      // set swatch styles
      const divEl = document.createElement('div');
      divEl.classList.add('blenders-tab-color-radiobutton-item');
      const labelEl = document.createElement('label');
      const inputEl = document.createElement('input');
      inputEl.setAttribute('type', 'radio');
      inputEl.setAttribute('name', 'attribute-option');
      inputEl.id = `threekit-swatch-input-${option}`;
      if (!threekit.variants[key]) inputEl.setAttribute('disabled', 'true'); // set disabled swatch
      if (configurationKey === option) inputEl.setAttribute('checked', 'true'); // set checked swatch
      const spanElParent = document.createElement('span');
      const spanElChild = document.createElement('span');
      spanElParent.classList.add('blenders-tab-color-radio-container');
      if (!!threekit.variants[key]) spanElParent.addEventListener('click', () => window.threekit.setAttributeOption(option));  // assign click function for active swatch
      spanElChild.classList.add('blenders-tab-color-radio');
      spanElChild.style = `background-image: url('${threekit.media[colorTitle]}');`
      swatchesContainer.appendChild(divEl);
      divEl.appendChild(labelEl);
      labelEl.appendChild(inputEl);
      labelEl.appendChild(spanElParent);
      spanElParent.appendChild(spanElChild);
    })
  }

  function toggleLoadingClasses() { // set player loading styles
    const loadingWrapper = document.getElementById("loading-wrapper");
    const eventWrapper = document.getElementById("event-wrapper");
    if (isPlayerLoading) {
      loadingWrapper.classList.add("loading-wrapper");
      eventWrapper.classList.add("loading-events");
    } else {
      loadingWrapper.classList.remove("loading-wrapper");
      eventWrapper.classList.remove("loading-events");
    }
  }

  function checkUrlForShowShades() {
    if (window.location.href.indexOf('showShades') !== -1) {
        threekit.setChangeModelOpen();
        removeFromUrl('&showShades');
    }
}

// This function removes the specified substring from the URL without reloading
function removeFromUrl(substr) {
    let newUrl = window.location.href.replace(substr, '');
    history.replaceState({}, '', newUrl);
}




  async function onPlayerLoadedUpdate(playerloaded) { // on initial player load
    const configurator = await window.player.getConfigurator();
    const attr = await configurator.getAttributes();
    // get all player options
    window.threekit.attributes = attr.reduce((acc, item) => ({ ...acc, [item.name]: item.values }), {});

    window.threekitModel = window.threekitModel || 'Millenia X2';
    threekit.postFix = threekit.modelToPostfix[threekitModel];

    setOptionList();

    if (playerloaded) {
      window.isPlayerLoading = false
      toggleLoadingClasses();
      checkUrlForShowShades();
    }
    product.selected_or_first_available_variant = product.variants[0];
 
  };

  Object.defineProperties(window, { // watch for player status change on init
    playerloaded: {
      writable: true
    },
    playerloaded: {
      get: function () { },
      set: function (val) {
        onPlayerLoadedUpdate(val);
      }
    },
  });

  window.threekit = threekit;

  document.addEventListener("DOMContentLoaded", async function () { // INIT DOM changes

    //modify DOM
    try {
      $("#cc-bod").css("background-color", "#FFFFFF")
    } catch (error) {

    }
    // get available shopify variants

    const LSeriesShopifyAttribute = {
      'Black Frame': 'BLF001',
      'Black Temples': 'BLT001',
      'Champagne Frame': 'BLF002',
      'Champagne Temples': 'BLT003',
      'Blue Frame': 'BLF003',
      'Blue Temples': 'BLT002',
      'Clear Frame': 'BLF004',
      'Clear Temples': 'BLT004',
      'Smoke Lens': 'BLL001',
      'Champagne Lens': 'BLL002',
      'Peach Lime Lens': 'BLL003',
      'Crystal Orb Lens': 'BLL004'
    };
    const MilleniaX2ShopifyAttribute = {
      'Black Frame': 'BLF005',
      'Black Temples': 'BLT005',
      'Champagne Temples': 'BLT008',
      'Blue Frame': 'BLF007',
      'Blue Temples': 'BLT006',
      'Champagne Frame': 'BLF006',
      'Clear Temples': 'BLT007',
      'Clear Frame': 'BLF008',
      'Smoke Lens': 'BLL005',
      'Champagne Lens': 'BLL006',
      'Peach Lime Lens': 'BLL007',
      'Crystal Orb Lens': 'BLL008',
    };

    window.threekit.productPrice = window.threekitProduct.price / 100;

    window.threekit.variants = window.threekitProduct.variants.reduce((acc, item) => { // get product available variants
      if (!item.available) {
        return acc;
      }
      let key = null;
      if (window.threekitProduct.handle == 'l-series-custom') {
        key = `${LSeriesShopifyAttribute[item.option1]}_${LSeriesShopifyAttribute[item.option2]}_${LSeriesShopifyAttribute[item.option3]}`;
      }
      else if (window.threekitProduct.handle == 'millenia-x2-custom') {
        key = `${MilleniaX2ShopifyAttribute[item.option1]}_${MilleniaX2ShopifyAttribute[item.option2]}_${MilleniaX2ShopifyAttribute[item.option3]}`;
      }
      return { ...acc, [key]: item.id };
    }, {});

    window.threekit.media = window.threekitProduct.media.reduce((acc, item) => { // get product swatch image src
      if (!item.alt) return acc;
      return { ...acc, [item.alt]: item.src };
    }, {});

    const sidebarEl = document.getElementById('threekit-sidebar');
    const modelTitle = document.getElementById('modelTitle');
    const productPrice = document.getElementById('product-price');
    sidebarEl.style.display = "block"; // show sidebar on init loading
    modelTitle.innerHTML = window.threekitModel;
    productPrice.innerHTML = `$${threekit.productPrice}`;
  });
})();
